import React, { useState, useEffect } from "react";
import Layout from '../form-layout'

export default function Step5({ formData, setFormData, onBack, goToStep }) {
  const [biologicalSex, setBiologicalSex] = useState(
    formData.biologicalSex || localStorage.getItem("biologicalSex") || ""
  );

  // Sync local state with formData and localStorage
  useEffect(() => {
    const saved = localStorage.getItem("biologicalSex");
    if (saved) {
      setBiologicalSex(saved);
      setFormData((prev) => ({ ...prev, biologicalSex: saved }));
    } else {
      setBiologicalSex(formData.biologicalSex || "");
    }
  }, [formData.biologicalSex, setFormData]);

  const handleSelect = (value) => {
    setBiologicalSex(value);
    setFormData({ ...formData, biologicalSex: value });
    localStorage.setItem("biologicalSex", value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!biologicalSex) return;
    goToStep("ethnicity");
  };

  return (
    <Layout goToStep={goToStep} onBack={onBack}>
      <div className="bg-white shadow-sm w-full max-w-xl px-6 sm:px-8 pt-8 pb-40 rounded-2xl">

        {/* Greeting / Heading */}
        <p className="text-sm sm:text-[14px] font-medium text-[#000000]  mb-6 leading-relaxed">
          Please select your biological sex.
        </p>

        {/* Options */}
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="flex items-center gap-8 mb-8 text-sm sm:text-[15px] text-[#111827]">
            {["Male", "Female"].map((option) => {
              const isSelected = biologicalSex === option;
              return (
                <label
                  key={option}
                  className={`inline-flex items-center gap-2 cursor-pointer p-3 rounded-lg  transition-colors
                   `}
                  onClick={() => handleSelect(option)}
                >
                  <input
                    type="radio"
                    name="biologicalSex"
                    value={option}
                    checked={isSelected}
                    onChange={() => handleSelect(option)}
                    className="h-4 w-4 accent-[#35C3D9]"
                  />
                  <span>{option}</span>
                </label>
              );
            })}
          </div>

          {/* Next Button */}
          <button
            type="submit"
            disabled={!biologicalSex}
            className={`w-[210px] bg-[#35C3D9] hover:bg-[#27AAC0] text-white text-sm font-semibold rounded-lg py-3 transition-colors
              ${!biologicalSex ? "opacity-50 cursor-not-allowed" : ""}`}
          >
            Next
          </button>
        </form>
      </div>
    </Layout>
  );
}
